import {isNotNil} from 'ramda';

import {DirectSaleState} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

const NON_EDITABLE_DIRECT_SALE_STATES: DirectSaleState[] = ['LOCKED', 'CLOSED', 'CORRECTING_FULLY'];

export const isNonEditableDirectSaleState = (state: DirectSaleState | Nullish) =>
  isNotNil(state) && NON_EDITABLE_DIRECT_SALE_STATES.includes(state);
